module.exports = __webpack_public_path__ + "img/image13.dbc3f3f3.png";